export default __webpack_public_path__ + "static/media/uk_gov_logo.ab999e77.png";